import { Color } from '../PrimitiveTypes'
import { OverridableStyleProperties } from './Styles'

export interface TextLayerStyle
  extends Omit<OverridableStyleProperties, 'originalSharedStyleValues'> {
  text: {
    verticalAlignment: VerticalTextAlignment
  }
  originalSharedStyleValues?: OverridableStyleProperties['originalSharedStyleValues'] & {
    text?: TextAttributes
  }
}

export interface TextAttributedString {
  string: string
  /** sub-strings. A text can have different styles. */
  attributes: TextPartialString[]
}

/**
 * Sub-string attributes
 */
export interface TextPartialString {
  /**
   * Position/index of the start of the sub-string relative to the full string
   */
  location: number
  /**
   * Length (number of chars) of the sub-string
   */
  length: number
  attributes: TextAttributes
}

/**
 * Attribute that can change per sub-string
 */
export interface TextAttributes {
  font?: Font
  color?: Color
  letterSpacing?: number
  paragraphStyle?: ParagraphStyle
  /**
   * Note: This is not used in the inspector,
   * we use the `verticalAlignment` property coming from
   * "text.style.text.verticalAlignment" instead
   */
  verticalAlignment?: VerticalTextAlignment
  transform?: TextTransform
  decoration?: TextDecoration
}

export interface ParagraphStyle {
  spacing?: number
  maxLineHeight?: number
  alignment?: HorizontalTextAlignment
  /** @deprecated: Doesn't seem to be used */
  minLineHeight?: number
}

export enum TextTransform {
  Uppercase = 'uppercase',
  Lowercase = 'lowercase',
}

export enum TextDecoration {
  LineThrough = 'line-through',
  Underline = 'underline',
}

export interface Font {
  family?: string
  weight?: string
  weightName?: string
  size?: number
  style?: string
  /** @deprecated, doesn't seem to be used */
  originalValue?: string
}

export type HorizontalTextAlignment = Exclude<
  TextAlignment,
  TextAlignment.Top | TextAlignment.Middle | TextAlignment.Bottom
>

export type VerticalTextAlignment = Exclude<
  TextAlignment,
  | TextAlignment.Left
  | TextAlignment.Center
  | TextAlignment.Right
  | TextAlignment.Justified
>

export enum TextAlignment {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom',
  Center = 'center',
  Justified = 'justified',
  Middle = 'middle',
}
